import React, { FC, useRef, useState } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const CommentsContainer = styled.div`
  width: 100%;
  max-width: 100%;
`

const StyledTextarea = styled.textarea<{ $isFocused: boolean }>`
  min-height: 44px;
  padding: 8px 12px;
  font-size: 0.75rem;
  font-family: inherit;
  line-height: 1.4;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  outline: none;
  width: 100%;
  background: ${(props) =>
    props.$isFocused ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  transition: background-color 0.2s ease;
  resize: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    border-color: rgba(255, 255, 255, 0.6);
  }
`

export const AnnotationNotesInput: FC<{
  editedAnnotation: KVAnnotation
  setEditedAnnotation: React.Dispatch<React.SetStateAction<KVAnnotation>>
}> = ({ editedAnnotation, setEditedAnnotation }) => {
  const [isFocused, setIsFocused] = useState(false)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const setNotes = (value: string) => {
    setEditedAnnotation((prev) => ({
      ...prev,
      notes: value,
    }))
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation()

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      textareaRef.current?.blur()
    }
  }

  return (
    <CommentsContainer>
      <StyledTextarea
        ref={textareaRef}
        value={editedAnnotation.notes}
        onChange={(e) => setNotes(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
        onKeyDown={handleKeyDown}
        onKeyUp={(e) => e.stopPropagation()}
        placeholder='Add comments...'
        $isFocused={isFocused}
      />
    </CommentsContainer>
  )
}
